module.exports = __webpack_public_path__ + "img/the-netherlands-liver-cancer-female.2ef7793a.png";